// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const {
  setInitialised,
  useArrows,
  setSlideAmount,
  addWheelControls,
  toggleRelatedItem,
} = window.BAO.Carousel.plugins

class NumberedListCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els?.slide?.selector,
        loop: true,
        mode: 'snap',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: '1',
        },
      },
      [
        setInitialised(),
        setSlideAmount(this.els?.count?.element),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
        toggleRelatedItem(this.els?.['related-caption']?.elements),
        toggleRelatedItem(this.els?.['related-hotspot-overlay']?.elements),
      ],
    )
  }
}

if (!customElements.get('numbered-list-carousel')) {
  customElements.define('numbered-list-carousel', NumberedListCarousel)
}
